import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=565baaf7&scoped=true&"
import script from "./QuestionComponent.vue?vue&type=script&lang=js&"
export * from "./QuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=565baaf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565baaf7",
  null
  
)

component.options.__file = "QuestionComponent.vue"
export default component.exports